
import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card, CardContent } from "@/components/ui/card";

const BiographySection = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-10 my-16">
      <div className="md:col-span-5">
        <div className="bg-white p-3 rounded-lg shadow-md">
          <AspectRatio ratio={3/4} className="overflow-hidden rounded-md">
            <img 
              src="/images/Capture24.jpg" 
              alt="Kaija Alliksaar" 
              className="w-full h-full object-cover"
            />
          </AspectRatio>
        </div>
      </div>
      
      <div className="md:col-span-7">
        <div className="space-y-6">
          <Card className="bg-gradient-to-br from-kaija-sage to-kaija-peach/70 border-none shadow-md">
            <CardContent className="pt-6">
              <h2 className="text-2xl font-medium mb-4">Minu lugu</h2>
              <div className="w-12 h-1 bg-kaija-slate/60 rounded-full mb-6"></div>
              <p className="text-gray-700 leading-relaxed">
                Olen juhtinud 25-liikmelist meeskonda üle 15 aasta. Hindan töötajate heaolu ning töö- ja eraelu tasakaalu. Isiklikus elus on mind õpetanud minu kaks teismelist tütart. Olen kogenud läbipõlemist, kaassõltuvust, ärevust ja depressiooni. Need kogemused on viinud mind muutusteni elustiilis ja enesehoolitsuses. Täna on minu elus olulisel kohal enda vajaduste märkamine, tervislik eluviis ja närvisüsteemi tasakaalustamine.
              </p>
            </CardContent>
          </Card>
          
          <Card className="border-none shadow-md">
            <CardContent className="pt-6">
              <h2 className="text-2xl font-medium mb-4">Minu visioon</h2>
              <div className="w-12 h-1 bg-kaija-slate/60 rounded-full mb-6"></div>
              <p className="text-gray-700 leading-relaxed">
                Luua teadlik ja kaastundlik keskkond, kus trauma mõju on arvestatud ning igaühel on võimalus kasvada ja saavutada isiklik ning professionaalne areng.
              </p>
            </CardContent>
          </Card>
          
          <Card className="border-none shadow-md">
            <CardContent className="pt-6">
              <h2 className="text-2xl font-medium mb-4">Minu missioon</h2>
              <div className="w-12 h-1 bg-kaija-slate/60 rounded-full mb-6"></div>
              <p className="text-gray-700 leading-relaxed">
                Toetada inimesi ja organisatsioone, aidates neil toime tulla elu väljakutsetega, suurendada vastupidavust ja rakendada oma sisemist potentsiaali. Loon turvalise ruumi, kus kasvada ja muutuda.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default BiographySection;
